import { init_state, ExtendedBasketProductItem } from "../basket/config";
import { basket_get_item_in_queue, basket_selector } from "../basket/selectors";
import { product_by_id_selector } from "../products/selectors";
import { State } from "..";

// basket
export { sync_queue_with_basket };

// This is useful when we are going to show immediate
// result to user without waiting for server.
// use case: add/remove from ProductScreen without
// openning Basket (to sync basket).
function sync_queue_with_basket(state: State, payload: any) {
  // Getting the latest status of a queue
  let item_in_queue = basket_get_item_in_queue(state, payload.product_id);

  if (item_in_queue) {
    // just quantity for now
    return mutate_basket_item(state, {
      product_id: payload.product_id,
      data: {
        item_in_queue,
      },
    });
  }
  return state;
}

function mutate_basket_item(state: State, { product_id, data }) {
  let basketData = basket_selector(state);

  // 1. if `data.items` exist -> new row
  // 2. if `data.items` exist and `product_id` was there
  //          -> update row
  // 3. if `data.items` exist and `product_id` wasn't there
  //          -> new row

  // we will updated the item, if we could find it
  // by `product_id`
  if (basketData && basketData.items) {
    let idx = basketData.items.findIndex(
      (item) => item.product_id == product_id
    );

    if (idx >= 0) {
      basketData.items[idx] = {
        ...basketData.items[idx],
        ...data.item_in_queue.quantity,
      };
      return state;
    }
  } else {
    // assinging an empty array, if the `items` doesn't exsit
    basketData.items = [];
  }

  // if there is no record in `data.items`,
  // we should create a temp record

  let temp = createTempItem(state, {
    product_id,
    item_in_queue: data.item_in_queue,
  });

  basketData.items.push(temp);
  return state;
}

function createTempItem(
  state,
  { product_id, item_in_queue }
): ExtendedBasketProductItem {
  let product = product_by_id_selector(product_id)(state);
  if (product) {
    return {
      id: `local_${product_id}`,
      price: product.price,
      product_id: product.id,
      product_title: product.title,
      quantity: item_in_queue.quantity,
      total_price: item_in_queue.quantity * product.price,
      status: item_in_queue.status,
    };
  }
}

// old

export default {
  reducer_logout(state) {
    return {
      ...state,
      basket: {
        ...init_state,

        // TEMP: i disabled it because it's possible
        // to login in different account and queue
        // shouldn't be synced for a wrong user.

        // we don't want to queue be removed.
        // data: init_state.data,
      },
      cart: [],
    };
  },
};
